import ControlledForm from '../Form/ControlledForm';
import {AuthLoginFormProps} from '../../@types/components/forms/AuthLoginForm';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

export default class AuthLoginForm<
        Model extends IEmptyModel = IEmptyModel
> extends ControlledForm<Model, AuthLoginFormProps<Model>> {
    static defaultProps = {
        formName: 'auth-login',
    };

    protected getLoadingIndicatorState(): boolean | undefined {
        if (this.props.accessToken) {
            return true;
        }

        return super.getLoadingIndicatorState();
    }

    protected async onSubmitRequestSuccess(res: any): Promise<any> {
        if ('token' in res) {
            this.props.setAccessToken(res.token);
        }

        return super.onSubmitRequestSuccess(res);
    }
}
